/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { SidebarGroup, SidebarMenu } from '@quadminds/mindkit';
import React, { useState } from 'react';
import { ChatItem } from './ChatItem/ChatItem';
import { ConversationItem } from '../../../../types/Conversation/Conversation';
import DeleteAlert from '../../../common/Alerts/Delete/Delete';

export function ChatList({
    items,
    ...props
}: {
    items: ConversationItem[];
} & React.ComponentPropsWithoutRef<typeof SidebarGroup>) {
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [id, setId] = useState('');
    return (
        <>
            <SidebarGroup {...props}>
                <SidebarMenu>
                    {items.map((item, index) => (
                        <ChatItem key={item.title + index} item={item} setDeleteOpen={setDeleteOpen} setId={setId} />
                    ))}
                </SidebarMenu>
            </SidebarGroup>
            <DeleteAlert open={deleteOpen} setOpen={setDeleteOpen} id={id} />
        </>
    );
}

export default ChatList;
